const Logger = require("../Logger");
const ConfigurationFactory = require("../ConfigurationFactory");
const ViewerDataInfo = require("../Data/ViewerDataInfo");
const Utils = require("../Utils");
const Config = require("../Config/Config");
const ScreenSharingUIController = require("../UI/ScreenSharingUIController");


const service = {};
const HTML_TEMPLATE_PARAMS = "?cid=CID&id=DID&presentationId=PID&frameElementId=FRAMEID&type=TYPE&viewerId=VIEWERID&screenSharingMode=SSMODE&screenSharingPin=SSPIN&screenSharingAuthenticationRequired=SSAUTH&memberDisplayName=DNAME";
const CACHE_BUSTER = "&cb=v5";

let cacheBusterSuffix = "";

const _buildUrl = (htmlName) => {
  return (Config.SCREEN_SHARING_URL + HTML_TEMPLATE_PARAMS + CACHE_BUSTER + cacheBusterSuffix)
    .replace("DID", ConfigurationFactory.getId())
    .replace("CID", ConfigurationFactory.getCompanyId())
    .replace("PID", "SCREEN_SHARING")
    .replace("FRAMEID", "iFrame_" + htmlName)
    .replace("TYPE", ConfigurationFactory.getType())
    .replace("VIEWERID", Utils.getUniqueId())
    .replace("SSMODE", ViewerDataInfo.getScreenSharingMode())
    .replace("SSPIN", ViewerDataInfo.getScreenSharingPin())
    .replace("SSAUTH", ViewerDataInfo.getScreenSharingAuthenticationRequired())
    .replace("DNAME", ConfigurationFactory.getDisplayName());
};

service.render = (htmlName, containerName) => {
  const width = ConfigurationFactory.getWindowWidth();
  const height = ConfigurationFactory.getWindowHeight();
  const top = 0, left = 0;

  Logger.logDebug(`ScreenSharingRenderer rendering ${htmlName} into container ${containerName}`);

  if (!htmlName || !containerName || !ViewerDataInfo.isScreenSharingEnabled()) {
    return;
  }

  const url = _buildUrl(htmlName);

  window.createURL(htmlName, containerName, width, height, top, left, 0, 0, url);

  RiseVision.Viewer.UI.ViewerZoomController.init(htmlName, width, height);
};

service.reload = (htmlName, containerName) => {
  cacheBusterSuffix = "&cb_reload=" + Date.now();
  Utils.destroyElement(htmlName, containerName);
  ScreenSharingUIController.reset();
  service.render(htmlName, containerName);
};

module.exports = service;
